// extracted by mini-css-extract-plugin
module.exports = {"blockBreakTime":"BreakTime_blockBreakTime__1rMW1"};